import * as getters from "./getters";
import * as actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    all: {},
    shareRequests: {},
    history: {},
    historyPaginator: {},
    shareRequestsPaginator: {},
  },
  mutations,
  actions,
  getters,
};
